import { SubmissionHeaderState } from '../types/document.types';

export const submissionFeatureKey = 'SubmissionHeader';
export const DEFAULT_SUBMISSION_HEADER_STATE: SubmissionHeaderState = {
  irbState: 'Normal',
};
